import {create} from 'zustand';
import {UseOpenBookingConfirmationDrawerStore} from './types';

const useOpenBookingConfirmationDrawerStore = create<UseOpenBookingConfirmationDrawerStore>(
	set => ({
		openBookingConfirmationDrawer: false,
		setOpenBookingConfirmationDrawer: value => set({openBookingConfirmationDrawer: value}),
	}),
);

export {useOpenBookingConfirmationDrawerStore};
